import { render, staticRenderFns } from "./CourseTestFinished.vue?vue&type=template&id=570c70ce&scoped=true&"
import script from "./CourseTestFinished.vue?vue&type=script&lang=ts&"
export * from "./CourseTestFinished.vue?vue&type=script&lang=ts&"
import style0 from "./CourseTestFinished.vue?vue&type=style&index=0&id=570c70ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570c70ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
